module.exports = __webpack_public_path__ + "img/code-reviewer.315ecfa7.webp";